<template>
  <div id="app">
    <!-- <Header v-if="excludeHeaderRoutes.indexOf($route.name) !== -1"></Header> -->
    <!-- <uleHeader  v-else-if="excludeUleHeaderRoutes.indexOf($route.name) !== -1" :categoryDataObj="categoryDatas"></uleHeader> -->
    <SubHeader></SubHeader>
    <router-view />
    <Footer></Footer>
    <!-- <router-view  @categoryData="getCategoryData"/> -->
    <!-- 部分路由不应该包含这个Footer -->
    <!-- <uleFooter v-if="excludeUleHeaderRoutes.indexOf($route.name) > -1"></uleFooter> -->
    <!-- <Footer v-if="excludeFooterRoutes.indexOf($route.name) == -1"></Footer> -->
  </div>
</template>

<script>
//import Header from '@/components/header/Header';
import SubHeader from "@/components/header/SubHeader";
//import uleHeader from '@/components/header/uleHeader';
import Footer from "@/components/footer/Footer";
//import uleFooter from '@/components/footer/uleFooter';
import store from "@/vuex/store";
import { mapState, mapMutations } from "vuex";
import { getDomain } from "@/util/common";
import request from "@/util/request";
export default {
  name: "App",
  data() {
    return {
      excludeFooterRoutes: ["HomeIndex", ""],
      excludeHeaderRoutes: ["Default", "GoodsList"],
      excludeUleHeaderRoutes: ["index"],
      excludeSubHeaderRoutes: [],
      categoryDatas: {
        categoryData: [],
        topIndex: "",
        offsetTops: []
      }
    };
  },
  computed: {
    ...mapState(["isIn919", "activeInfo919"])
  },
  components: {
    //Header,
    SubHeader,
    //uleHeader,
    Footer
    //uleFooter
  },
  mounted() {
    this.get919Recomand();
  },
  created() {},
  methods: {
    getCategoryData(val) {
      this.categoryDatas = val;
    },
    get919Recomand() {
      // 获取919弹窗信息
      let url = `https://ustatic.${getDomain()}ulecdn.com/mobilead/itemRecommend/sectionList/getTmplSection21/event2023919_countdown_time/0?202308141910`;
      request.jsonp(url, {}, "", "getTmplSection21").then(res => {
        console.log("get919Recomand", res);
        const timeData = res.event2023919_countdown_time
          ? res.event2023919_countdown_time[0]
          : {};
        const customAttribute = timeData.customAttribute || undefined;

        if (customAttribute) {
          const {
            countdownTime1,
            countdownTime2,
            imgUrlPc1,
            imgUrlPc2
          } = customAttribute;
          if (
            countdownTime2 &&
            new Date(countdownTime2).getTime() > new Date().getTime()
          ) {

            store.commit("setIsIn919", true);
            sessionStorage.setItem("isIn919", true);
            store.commit("setActivityInfo919", customAttribute);
            sessionStorage.setItem(
              "activityInfo919",
              JSON.stringify(customAttribute)
            );
          } else {
            store.commit("setIsIn919", false);
            sessionStorage.setItem("isIn919", false);
          }
        }
      });
    }
  },
  store
};
</script>



// WEBPACK FOOTER //
// src/App.vue